import script from "./AccountSetSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSetSettings.vue?vue&type=script&setup=true&lang=js"

import "./AccountSetSettings.vue?vue&type=style&index=0&id=1a173dca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a173dca"]])

export default __exports__